// components
import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import { ContentfulToolbar } from 'src/components/ContentfulToolbar';
import { TemplateWrapper } from 'src/templates';

// helpers
import LegacyScripts from 'src/components/LegacyScripts';
import { CmsThemes, ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';

const propTypes = {
  fields: TemplateFieldShape.isRequired,
};

const PartnerDirectoryTemplate = ({ fields }) => {
  return (
    <TemplateWrapper
      meta-title={fields?.metaTitle}
      meta-description={fields?.metaDescription}
      hasFooterCta={false}
      cmsTheme={CmsThemes.WEB3}
    >
      <div data-testid={ContentfulTemplates.PARTNER_DIRECTORY}>
        <CmsComponentSwitch components={fields?.components} />
      </div>
      <LegacyScripts />
      <ContentfulToolbar />
    </TemplateWrapper>
  );
};
PartnerDirectoryTemplate.propTypes = propTypes;

export default PartnerDirectoryTemplate;
